import React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { Button } from "@project-stories/elements/Button/Button";

interface MinicartEmptyStateProps {
  settings: {
    empty_text_one?: string;
    empty_text_one_style?: string;
    empty_text_two?: string;
    empty_text_two_style?: string;
    empty_button_text?: string;
    empty_button_text_style?: string;
  };
  onClose: () => void;
}

export const MinicartEmptyState = ({ settings, onClose }: MinicartEmptyStateProps) => {
  const textOne = settings?.empty_text_one || "Your bag is empty";
  const textTwo = settings?.empty_text_two || "Add items to get started";
  const buttonText = settings?.empty_button_text || "Continue Shopping";
  
  const textOneStyle = settings?.empty_text_one_style || "h4 font-medium";
  const textTwoStyle = settings?.empty_text_two_style || "text-base text-gray-600";
  const buttonTextStyle = settings?.empty_button_text_style || "font-medium";
  
  return (
    <div className="minicart-empty-state flex flex-col items-center justify-center py-12 px-4 text-center gap-[12px]">
      <div className="empty-cart-icon mb-6">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 20V16C20 11.6 23.6 8 28 8H36C40.4 8 44 11.6 44 16V20" stroke="#000000" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M52 24V56H12V24H52Z" stroke="#000000" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <Paragraph classes={textOneStyle} text={textOne} />
      <Paragraph classes={textTwoStyle} text={textTwo} />
      
    
      <Button style={"primary !px-4"} className="hidden" label={`${buttonText}`} onClick={onClose} />
 
    </div>
  );
};